import httpClient from '../../utils/httpClient';

/* Get Invoice PDF */
export async function getInvoicePDF(routeToken, invoiceId) {
  try {
    const pdfRequestConfig = {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/pdf',
      },
    };

    const toObjectUrl = (data, contentType) => {
      const blob = new Blob([data], { type: contentType });
      return URL.createObjectURL(blob);
    };

    const contentType = (res) => res?.headers?.['content-type'];

    const response = await httpClient().get(
      `/invoices/${routeToken}/${invoiceId}`,
      pdfRequestConfig
    );

    if (response?.status === 403) {
      throw new Error('Unathorized to access this invoice', response);
    }

    const responseData = {
      invoiceId,
      pdf: toObjectUrl(response?.data, contentType(response)),
    };

    return await responseData;
  } catch (error) {
    console.error('Error fetching invoice:', error);
    throw error;
  }
}
